module.exports = __webpack_public_path__ + "img/wifi-login.aa29b8ae.png";